import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { useTranslation } from "react-i18next";
import { z } from "zod";

const tableName = "g4_dynamic_data";

const filterG4DynamicDataSchema = z.object({
  strategy_id_equals: z.string().optional(),
  portfolio_id_equals: z.string().optional(),
  instrument_type_contains: z.string().optional(),
  date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterG4DynamicDataSchema = z.infer<
  typeof filterG4DynamicDataSchema
>;

export function FilterG4DynamicData() {
  const { t } = useTranslation("tables");

  const fields: Field[] = [
    {
      name: "portfolio_id_equals",
      label: t(`${tableName}.searchbox.portfolio_id_equals`, {
        defaultValue: "Portefeuille (id)",
      }),
      type: "input",
    },
    {
      name: "strategy_id_equals",
      label: t(`${tableName}.searchbox.strategy_id_equals`, {
        defaultValue: "Stratégie (id)",
      }),
      type: "input",
    },
    {
      name: "instrument_type_contains",
      label: t(`${tableName}.searchbox.instrument_type_contains`, {
        defaultValue: "Instrument type",
      }),
      type: "input",
    },
    {
      name: "date",
      type: "dateRange",
      label: "Date",
      from: { name: "date_from" },
      to: { name: "date_to" },
      copy_from_to_when_to_empty: true,
      col_span: 2,
    },
  ];

  return (
    <FilterTable
      columns={2}
      client="g4"
      schema={filterG4DynamicDataSchema}
      tableName="g4_dynamic_data"
      fields={fields}
    />
  );
}
